import React, { useState } from "react"
import { ArrowSquareOutIcon, XIcon } from "@phosphor-icons/react"
import {
  Dialog,
  DialogPanel,
} from "@headlessui/react"
import { Link } from "gatsby"
import SoftButton from "@components/common/SoftButton"
import SwimSection from "@components/Products/SizeAndFitnessGuide/SwimSection"
import MensApparel from "@components/Products/SizeAndFitnessGuide/MensApparel"
import WomensApparel from "@components/Products/SizeAndFitnessGuide/WomensApparel"

const ViewSizeGuideModal = ({
	isOpen = false,
	onClose = () => {},
	hideSwimButton = false,
	hideWomensButton = false,
	hideMensButton = false,
}) => {
	const [activeCategory, setActiveCategory] = useState('swim')
	const openState = isOpen || false;

	return (
		<React.Fragment>
			<Dialog open={openState} onClose={onClose} className="relative z-[102]">
				<div className="fixed inset-0 w-screen overflow-y-auto p-4 bg-black bg-opacity-60">
					<div className="flex min-h-full items-center justify-center">
						<DialogPanel className="relative space-y-4 border bg-white p-6 max-w-[1380px] max-h-[720px] overflow-y-auto minimalist-scrollbar gap-6">
							<div className="flex flex-nowrap justify-between items-center">
								<h2 className="font-semibold m-0">SIZING & FIT GUIDE</h2>
								<XIcon
									className="cursor-pointer text-black"
									size={32}
									weight="light"
									onClick={onClose}
								/>
							</div>

							{!(hideSwimButton && hideMensButton && hideWomensButton) && (
								<section className="flex flex-nowrap overflow-x-scroll md:overflow-x-auto px-1">
									{!hideSwimButton && (
										<SoftButton
											label={"Swim"}
											className={`px-4 py-2 rings-on-hover text-lg w-auto my-2 ${
												activeCategory === "swim" && "rings-on-active"
											}`}
											defaultSelected={true}
											onClick={() => setActiveCategory("swim")}
											ariaLabel={`Size Guide Swim`}
										/>
									)}
									{!hideWomensButton && (
										<SoftButton
											label={"Women's Apparel"}
											className={`px-4 py-2 rings-on-hover text-lg w-auto my-2 ${
												activeCategory === "women" && "rings-on-active"
											}`}
											onClick={() => setActiveCategory("women")}
											ariaLabel={`Size Guide Women Apparel`}
										/>
									)}
									{!hideMensButton && (
										<SoftButton
											label={"Men's Apparel"}
											className={`px-4 py-2 rings-on-hover text-lg w-auto my-2 ${
												activeCategory === "men" && "rings-on-active"
											}`}
											onClick={() => setActiveCategory("men")}
											ariaLabel={`Size Guide Men Apparel`}
										/>
									)}
								</section>
							)}

							<section className="grid grid-cols-4 w-full gap-8">
								<div className="col-span-4 lg:col-span-1 space-y-5">
									<p>
										The right fit is key to feeling confident. Use our size
										guide to find your perfect match. Some styles may run
										smaller or larger—check individual product descriptions. If
										you’re between sizes, we suggest sizing up.
									</p>
									<div>
										<h2>STYLE GUIDE</h2>
										<p>
											Discover our{" "}
											<Link to="/bikini-style-guide" className="link-style">
											<span className="flex gap-x-2 items-center">
												Bikini Style Guide <ArrowSquareOutIcon size={20} />
											</span>
											</Link>{" "}
											for the perfect cut and coverage.
										</p>
									</div>

									<div>
										<h2>RETURN POLICY</h2>
										<p>
											We offer FREE returns for store credit 30 days from date
											of receipt. Items must be unworn, unwashed, undamaged and
											not marked as FINAL SALE
										</p>
										<a 
											className="link-style mt-2" 
											href='https://black-bough-swim.reamaze.com/kb/returns' target="_blank"
										>
											<span className="flex gap-x-2 items-center">
												Return Policy <ArrowSquareOutIcon size={20} />
											</span>
										</a>
										{/* <Link to="#" className="link-style mt-2">
											<span className="flex gap-x-2 items-center">
											Return Policy <ArrowSquareOutIcon size={20} />
											</span>
										</Link> */}
									</div>
								</div>

								<div className="col-span-4 lg:col-span-3 w-full space-y-4">
									{activeCategory === "swim" ? (
										<SwimSection />
									) : activeCategory === "women" ? (
										<WomensApparel />
									) : activeCategory === "men" ? (
										<MensApparel />
									) : (
									""
									)}
								</div>
							</section>
						</DialogPanel>
					</div>
				</div>
			</Dialog>
		</React.Fragment>
	);
}

export default ViewSizeGuideModal
